import React from "react"
import { Box } from "@mui/material"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"
import { autoEuropeProviderNormalizationDrawerData, autoEuropeProviderNormalizationDrawerErrors, clearAutoEuropeProviderNormalizationSignals } from "Pages/AutoEuropeTool/ProviderNormalization/@signals"

export default function AutoEuropeProviderNormalizationFooter({ onSubmit, isLoading }) {
	return <Box>
		<ButtonLoadingSeeker
			sx={{ m: 1 }}
			startIcon={<IconSeeker icon="circle-left" tooltip="Cancel"/>}
			onClick={clearAutoEuropeProviderNormalizationSignals}
			variant="outlined"
		>
			Cancel
		</ButtonLoadingSeeker>
		<ButtonLoadingSeeker
			sx={{ m: 1 }}
			loading={isLoading}
			startIcon={<IconSeeker icon="floppy-disk" tooltip="Save"/>}
			disabled={!Object.values(autoEuropeProviderNormalizationDrawerErrors.value).every(a => a)}
			onClick={() => onSubmit(autoEuropeProviderNormalizationDrawerData.value)}
		>
			Save
		</ButtonLoadingSeeker>
	</Box>
}
